import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sw-swipe-angular-list',
  template: `
    <p>
      swipe-angular-list works!
    </p>
  `,
  styles: []
})
export class SwipeAngularListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
